module.exports = __webpack_public_path__ + "media/entities/2107-925995ee.png";